import React from 'react';
import * as Styled from './confirmationStyled';

const Modal = props => (
  <Styled.ModalMainDiv>
    <Styled.ModalDiv style={{ transform: props.show ? 'translateY(0)' : 'translateY(-100vh)', opacity: props.show ? 1 : 0 }}>
      <Styled.HeadingDiv>{props.heading}</Styled.HeadingDiv>
      <Styled.SaveWrapDiv>
        <Styled.CancelButton onClick={e => props.close(e)}>Cancel</Styled.CancelButton>
        { props.type === 'confirm' ?
          <Styled.SaveButton onClick={e => props.confirm(e)}>{props.buttonText}</Styled.SaveButton>
        : ''
        }
      </Styled.SaveWrapDiv>
    </Styled.ModalDiv>
    <Styled.ModalWrapDiv onClick={e => props.close(e)} style={{ display: props.show ? 'block' : 'none' }} />
  </Styled.ModalMainDiv>
)

export default Modal
